import { ActionTypes } from "../actions";

const INITIAL_STATE = {
  currencies: {}
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ActionTypes.CURRENCIES:
      return {
        ...state,
       currencies: action.payload
      };

    default:
      return state;
  }
};
